// src/pages/etudiant/Accueil.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function Accueil() {
    return (
        <div className="bg-gray-50 min-h-screen flex items-center justify-center p-4">
            <div className="container max-w-2xl bg-white rounded-2xl shadow-xl overflow-hidden">
                {/* En-tête avec logo et titre */}
                <div className="bg-primary text-white px-4 py-4 flex items-center gap-4 border-b-4 border-secondary">
                    <img 
                        src="/images/logoiss.png" 
                        alt="ISS Logo" 
                        className="h-10 w-auto bg-white p-1 rounded"
                    />
                    <div>
                        <h1 className="text-lg sm:text-xl font-serif font-bold m-0 text-white">
                            🎓 Portail Étudiant
                        </h1>
                        <p className="text-[10px] sm:text-xs text-white m-0">
                            Accédez à vos formations ou découvrez les formations publiques
                        </p>
                    </div>
                </div>

                <div className="p-3 sm:p-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {/* Carte 1 : Mes Formations */}
                        <Link 
                            to="/login?role=etudiant"
                            className="card text-center hover:shadow-lg transition-all border-2 border-transparent hover:border-primary p-3 sm:p-4"
                        >
                            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-primary-bg rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="text-2xl sm:text-3xl">🎓</span>
                            </div>
                            <h3 className="text-base sm:text-lg font-serif font-bold text-gray-800">
                               Votre Portail Etudiant
                            </h3>
                            <p className="text-[10px] sm:text-xs text-gray-500 mt-1">
                                Accédez avec vos informations recus par mail.
                            </p>
                            <span className="inline-block mt-3 text-primary font-semibold text-[10px] sm:text-xs">
                                Se connecter →
                            </span>
                        </Link>

                        {/* Carte 2 : Inscription Publique */}
                        <Link 
                            to="/inscription?mode=demander"
                            className="card text-center hover:shadow-lg transition-all border-2 border-transparent hover:border-secondary p-3 sm:p-4"
                        >
                            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-secondary-bg rounded-full flex items-center justify-center mx-auto mb-3">
                                <span className="text-2xl sm:text-3xl">📝</span>
                            </div>
                            <h3 className="text-base sm:text-lg font-serif font-bold text-gray-800">
                                Les Inscriptions Publiques
                            </h3>
                            <p className="text-[10px] sm:text-xs text-gray-500 mt-1">
                                Découvrez et inscrivez‑vous en selectionnant.
                            </p>
                            <span className="inline-block mt-3 text-secondary font-semibold text-[10px] sm:text-xs">
                                S'inscrire →
                            </span>
                        </Link>
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-gray-50 px-4 py-2 text-center text-[10px] sm:text-xs text-gray-400 border-t border-gray-200">
                    © 2026 Ivoire Soft Services – Plateforme de Formation
                </div>
            </div>
        </div>
    );
}